import type ISchoolYearRepository from '@/core/domain/school/year/ISchoolYearRepository'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory'
import SchoolYear from '@/core/domain/school/year/SchoolYear'

export default class SchoolYearRepository implements ISchoolYearRepository {
  async fetchSchoolYearById(): Promise<SchoolYear> {
    throw new Error('Method not implemented.')
  }

  async fetchAllSchoolYears(): Promise<SchoolYear[]> {
    const response = await apiService.get<SchoolYear[]>(`admin/school-years`)

    if (!Array.isArray(response.data)) {
      throw new Error('Expected array response for school years')
    }

    return response.data.map((schoolYear) => SchoolYear.create(schoolYear))
  }

  async updateSchoolYear(): Promise<SchoolYear> {
    throw new Error('Method not implemented.')
  }

  async fetchSchoolYear(schoolYearId: number): Promise<SchoolYear> {
    throw new Error('Method not implemented.')
  }
}
